FD.CONTROL = (function ($, me) {
    'use strict';

    var child = me.CONTROL || {};


    /* ========================================================================
     *  private vars
     * ========================================================================
    */

    const ELEM = '[data-fd="autocomplete"]';
    const DELAY = 800; // Milliseconds
    const LANGUAGETYPE = [
        "English",
        "Spanish",
        "Chinese",
        "Hungarian",
        "Slovakian"
    ]
    const URL = "/Common/Common/";
    var eventsWired = false;

    var ACTYPE = {
        NONE: -1,
        USER: 1,
        CELL: 2,
        DIVISION: 3,
        CR: 4,
        DIVISIONCELLUSER: 5,
        DIVISIONCELLCR: 6,
        DIVISIONCELL: 7,
        DIVISIONCELLCRUSER: 8,
        MONTHLYMETRIC: 9,
        COMPANY: 10,
        COMPANYLOCATION: 11,
        UNIVERSALUSER: 12,
        PROJECTLIST: 13,
        FOCUSFACTORY: 14,
        SUPERCELL: 15,
        MACHINE: 16,
        STATION: 17,
        CUSTOMER: 18,
        VIEWID: 19,
        CRMENTOR: 20,
        INNOTECPART: 21,
        CUSTOMERPART: 22,
        NONFAILUREINTERVENTION: 23,
        DOWNTIMEISSUE: 24,
        MANUALPROCESS: 25,
        SCRAPDEFECT: 26,
        TAG: 27,
        EIGHTD: 28,
        TECHNICALCR: 29,
        CONTACT: 30,
        DOWNTIMEWARNING: 31,
        SPAREPARTLOCATION: 32,
        FOXENTITY: 33,
        USERCOMPLETELIST: 34,
        PROJECTENTITYLIST: 35,
        PROJECTMETRICACCOUNTS: 36,
        OTEACCOUNTS: 37,
        DIVISIONFOCUSFACTORYCELL: 38,
        INNOTECDIVISIONCELLCRUSER: 39,
        TRAININGMATRIXPLAYLIST: 40,
        DIVISIONGROUPDIVISIONFOCUSFACTORYSUPERCELLCELLMACHINESTATION: 41,
        MPTUSERS: 42,
        DIVISIONFOCUSFACTORY: 43,
        MANUALLABORCOMPANYLOCATION: 44,
        BOTRESPOSIBILITYPARENT: 45,
        ONEPPRESPOSIBILITYPARENT: 46,
        ONEPP_RESPONSIBILITY_ALL: 47,
        MPTUSERS_WITHCOMPANY: 48,
        JOB: 49,
        CONTPAQ_PRODUCTS: 50,
        USERS_EXCEPT_FULLTIME: 51,
        UNLINKED_SPARE_PART_PARTS: 52,
        UNLINKED_CONTPAQ_PRODUCTS: 53,
        PURCHASED_MATERIAL: 55,
        NON_CONTPAQ_VENDORS: 56,
        CONTPAQ_VENDORS_ONLY: 57,
        TRAINING_MATRIX_TEMPLATE: 59,
        JOB_EXCLUDE_LINKED: 60,
        TRAINING_MATRIX_ENTITY: 61,
        COMPANY_LOCATIONS_WITH_BOM: 62,
        COMPANY_LOCATIONS_WITH_SALES_ORDER: 63,
        NON_CUSTOMER_LOCATION: 64,
        LEARNING_SUITE_RESOURCE_TASKS: 65,
        CHILD_ACCOUNT: 66,
        JOB_BY_USER: 68,
        SHIPTO: 69,
        COMPANY_LOCATIONS_WITH_BOM_SHIPTO: 70,
        DIVISON_EXCLUDE_CORPORATE_DIVSISIONS: 71,
        FOCUS_FACTORY_EXCLUDE_CORPORATE_DIVISIONS: 72,
        SUPER_CELL_EXCLUDE_CORPORATE_DIVISIONS: 73,
        NON_SUPPLIER_LOCATION: 74,
        NON_CUSTOMER_SUPPLIER_LOCATION: 75,
        INTERNALPARTS_WITHOUT_SAME_CELL: 76,
        PONUMBER: 77,
        PDT_PROJECT_NUMBER: 78,
        SHIPTO_AND_CELL_LIST: 79,
        PROJECT_COLLECTION: 80,
        PACKAGING_MATERIAL: 81,
        MATERIALPO_CONTPAQ_PRODUCTS: 82,
        INNOTECPART_WITHOUT_CELLNAME: 83,
        NON_PACKAGING_PURCHASED_MATERIAL: 84,
        PROJECT_TASK_ENTITY: 85,
        PURCHASED_MATERIAL_FROM_PACKAGING: 86,
        COMPANY_WITH_ELECTRONIC_MANUFACTURER: 87,
        COMPANY_LOCATION_AND_CELLLIST: 88,
        CR_AND_USER: 89,
        EIGHTD_WITH_NAME: 92,
        MACHINE_PART: 93,
        CUSTOMERPART_WITH_SHIPTO_DESCRIPTION: 94,
        CUSTOMERPART_BY_SALESORDER: 95,
        HTSCODETARIFF: 96,
        PLANENTITY: 97,
        PARTFAMILY: 98,
        SALESADJUSTMENTENTITY: 99,
        MANUALPROCESSTEAM: 100,
    };

    $.widget("custom.autocomplete2", {
        _active: false,
        _isSelect: false,
        _hiddenItem: null,
        _clearItem: null,

        options: {
            useparent: true,
            parentid: -1,
            callback: 'PAGE.getAfterControlEvent',  //  default
            tag: 500,
            noedit: false,
            height: 200,                //  height of the dropdown
            type: ACTYPE.USER,          //  actype
            fieldafter: '',             //  field to put value after change
            clearexit: false,
            usesubpage: false,
            useparent: true,
            flip: false,
            initial: "",
            clearbtn: false,
            clearonload: false,
            searchparams: '', // extra filter to apply on search
            name: '' // Add a hidden filed with the string value (for form postbacks)
        },
        _create: function () {
            $.extend(this.options, this.element.data());

            if (!eventsWired) {
                $(document)
                    .on('focus.ac,click.ac', ELEM, this._handleFocusClick)
                    .on('blur.ac', ELEM, this._handleBlur)
                    .on('keyup.ac', ELEM, this._handleKeyUp)
                    .on('click', '.autocomplete-clearbtn', this._handleClickClear);

                eventsWired = true;
            }

            me.setControlItemOptions(this.element, this.options);

            this._hiddenItem = $("<input>").attr({
                type: "hidden",
                name: this.element.attr('name'),
                value: this.options.value ? this.options.value : this.options.initial
            });


            // Use the original import to post the string value for postbacks.
            if (this.options.name) {
                this.element.attr("name", this.options.name);
            } else {
                this.element.removeAttr("name");
            }

            this.element.data('update', 'ignore');
            this.element.after(this._hiddenItem);
            this.options.type = this.options.type.toLowerCase();


            if (this.options.usesubpage) {
                this.options.callback = 'PAGE.SUBPAGE.getAfterControlEvent';
            }

            // if use parent
            if (this.options.useparent) {
                var parent = this.element.closest('[data-parent=true]');
                this.options.parentid = parent.data("parentid");
                var parentCallBack = me.setCallBackPrefix(parent.data('callbackprefix'));
                if (parentCallBack !== undefined) {
                    this.options.callback = parentCallBack;
                }
            }

            if (this.options.noedit) {
                this.element.attr('readonly', true).css({ cursor: 'default' });
            }

            if (this.options.clearbtn) {
                this._clearItem = $('<i>')
                    .addClass('fa fa-fw fa-ban autocomplete-clearbtn')
                    .css("cursor", "pointer");
                this.element.after(this._clearItem);
            }

            if (this.options.clearonload) {
                this.options.clearonload = false;
                this.element.val("").data("clearonload", false).attr("data-clearonload", false);
                this._hiddenItem.val("");
            }

            // Create the autocomplete
            var position = this.options.flip ? {
                my: "left bottom",
                at: "left top",
                collision: "flip"
            } : {
                my: "left top",
                at: "left bottom",
                collision: "flip"
            };
            var self = this;

            this.element.autocomplete({
                minLength: 1,
                delay: DELAY,
                autoSelect: true,
                autoFocus: true,
                focus: () => false, // dont fill input with highlighted value
                source: function (request, response) {
                    if (request.term.trim().length < 2) {
                        return;
                    }

                    var inputProps = {
                        searchTerm: me.setHtmlEncode(request.term.trim()),
                        searchParams: self.options.searchparams ? self.options.searchparams.toString().split(',') : [],
                        autoCompleteType: ACTYPE[self.options.type.toUpperCase()]
                    };

                    //  lock screen [prevent page scroll]
                    $('body').addClass('out');

                    //  get source
                    var options = {
                        params: inputProps,
                        url: URL + 'GetAutoCompleteByType',
                        callback: (data) => self._getDataSourceResult.call(self, data.data, response),
                        isloader: true
                    };
                    me.AJAX.setAJAX(options);
                },
                select: function (event, ui) {
                    event.stopPropagation();
                    self._activate = true;
                    self._isSelect = true;
                    self.element.val(ui.item.label);

                    //  callback
                    self.options.value = ui.item.value;
                    self.element.attr("data-value", ui.item.value);
                    self._hiddenItem.val(ui.item.value);
                    var result = {
                        e: self.element,
                        value: ui.item.value,
                        tag: self.options.tag,
                        fieldafter: self.options.fieldafter,
                        parentid: self.options.parentid,
                        label: ui.item.label,
                        initial: self.options.initial || null,
                        raw: ui.item
                    };

                    switch (ui.item.acType) {
                        case ACTYPE.TRAINING_MATRIX_ENTITY:
                            result.entityType = ui.item.entityType;
                            result.isCustomUserGroup = ui.item.isCustomUserGroup;
                            break;
                        default:
                            result.usertype = ui.item.usertype || null;
                            result.guid = ui.item.guid;
                            break;
                    }
                    self.element.data(self.options);
                    me.setCallBackFromData(self.element, result);
                    // Make sure the update happens on initial selection.
                    self.element.trigger('blur');
                    self._hiddenItem.trigger('change')
                    return false;
                },
                close: function (event) {
                    self._activate = true;
                    $('body').removeClass('out');
                    if (!self._isSelect) {
                        self.element.val(self.options.initial);
                    }
                    self._isSelect = false;

                    if (self.options.clearexit) {
                        self.element.val('').focus();
                    }
                },
                position: position
            }).autocomplete("instance")._renderItem = function (ul, item) {
                ul.css({
                    'max-height': self.options.height + 'px',
                    'overflow-y': 'auto',
                    'overflow-x': 'hidden'
                });

                var entityType = item.entitytype;

                if (entityType === ACTYPE.USER || entityType === ACTYPE.USERCOMPLETELIST) {
                    var image = item.userImage;
                    var style = " background-image:url(" + image + ");";

                    if (item.guid === undefined) {
                        style = '';
                    }
                    return $("<li>")
                        .append("<div class='user-autocomplete'><div class='image' style='" + style + "'></div><div class='content'>" + item.label + "</div></div>")
                        .appendTo(ul);
                }

                return $("<li>")
                    .append("<div>" + item.label + "</div>")
                    .appendTo(ul);
            };

            this.element.data(this.options);
            this.element.addClass("autocomplete");
            this.refresh();
        },
        _setOptions: function (options) {
            this._super(options);
            this.element.data(options);
            this.refresh();
        },
        refresh: function () {
            this.element.attr({
                'data-tag': this.options.tag,
                'data-noedit': this.options.noedit
            });
            this.element.attr('disabled', this.options.noedit);
        },
        attach: function (self) {
            this.element = self;
        },
        _destroy: function () {
        },

        _handleFocusClick: function (event) {
            var self = $(event.target).closest(ELEM).data('customAutocomplete2');
            self.options.initial = self.element.val();
            self.element.val('');
        },
        _handleBlur: function (event) {
            var self = $(event.target).closest(ELEM).data('customAutocomplete2');
            if (!self._activate) {
                self.element.val(self.options.initial);
            }
            self._activate = false;
        },
        _handleKeyUp: function (event) {
            var self = $(event.target).closest(ELEM).data('customAutocomplete2');

            if (Number(event.which) === 27 || Number(event.keyCode) === 27) {
                self.element.val(self.options.initial);
                return;
            }
        },
        _handleClickClear: function (event) {
            var self = $(event.target).prev().data('customAutocomplete2');

            if (!self.options.parentid) {
                self.options.parentid = self.element.closest('[data-parent="true"]').data('parentid');
            }

            if (self.element.val()) {
                self.options.value = '';
                self.element.val('').data('value', '');
                var result = {
                    e: self.element,
                    value: -1,
                    usertype: null,
                    guid: null,
                    tag: self.options.tag,
                    parentid: self.options.parentid,
                    fieldafter: self.options.fieldafter,
                    initial: self.options.initial,
                    label: null
                };
                me.setCallBackFromData(self.element, result);
                self.element.data(self.options);
                self._hiddenItem.val(-1).trigger('change');
                self.element.trigger('change');
            }
        },

        _getDataSourceResult: function (result, response) {

            switch (ACTYPE[this.options.type.toUpperCase()]) {
                case ACTYPE.COMPANY:
                case ACTYPE.COMPANY_WITH_ELECTRONIC_MANUFACTURER:
                case ACTYPE.TRAINING_MATRIX_TEMPLATE:
                    response($.map(result, function (item) {
                        return {
                            entitytype: -1,
                            label: item.Name,
                            guid: null,
                            initial: null,
                            parentID: null,
                            value: item.ID,
                            userImage: null
                        };
                    }));
                    break;
                case ACTYPE.MANUALLABORCOMPANYLOCATION:
                    response($.map(result, function (item) {
                        return {
                            entitytype: -1,
                            label: item.Name,
                            guid: null,
                            initial: null,
                            parentID: item.ParentID,
                            value: item.ID,
                            userImage: null
                        };
                    }));
                    break;
                case ACTYPE.BOTRESPOSIBILITYPARENT:
                case ACTYPE.ONEPPRESPOSIBILITYPARENT:
                case ACTYPE.INTERNALPARTS_WITHOUT_SAME_CELL:
                case ACTYPE.INNOTECPART_WITHOUT_CELLNAME:
                    response($.map(result, function (item) {
                        return {
                            entitytype: -1,
                            label: item.StandardName,
                            guid: null,
                            initial: null,
                            parentID: item.ParentID,
                            value: item.ID,
                            userImage: null
                        };
                    }));
                    break;
                case ACTYPE.UNIVERSALUSER:
                    response($.map(result, function (item) {
                        return {
                            entitytype: -1,
                            label: item.Name,
                            guid: null,
                            initial: null,
                            parentID: item.ParentID,
                            value: item.ID,
                            usertype: item.UserType,
                            userImage: item.UserImage
                        };
                    }));
                    break;
                case ACTYPE.PROJECTLIST:
                    response($.map(result, function (item) {
                        return {
                            entitytype: -1,
                            label: item.ManagedName,
                            guid: null,
                            initial: null,
                            parentID: null,
                            value: item.ManagedID,
                            usertype: null,
                            userImage: item.UserImage
                        };
                    }));
                    break;
                case ACTYPE.FOCUSFACTORY:
                case ACTYPE.FOCUS_FACTORY_EXCLUDE_CORPORATE_DIVISIONS:
                case ACTYPE.SUPERCELL:
                case ACTYPE.SUPER_CELL_EXCLUDE_CORPORATE_DIVISIONS:
                case ACTYPE.MACHINE:
                case ACTYPE.STATION:
                case ACTYPE.CRMENTOR:
                case ACTYPE.INNOTECPART:
                case ACTYPE.CUSTOMERPART:
                case ACTYPE.MANUALPROCESS:
                    response($.map(result, function (item) {
                        return {
                            entitytype: -1,
                            label: item.DisplayName,
                            guid: null,
                            initial: null,
                            parentID: null,
                            value: item.ManagedID,
                            usertype: null,
                            userImage: null
                        };
                    }));
                    break;
                case ACTYPE.VIEWID:
                    response($.map(result, function (item) {
                        return {
                            entitytype: -1,
                            label: item.DisplayName,
                            guid: null,
                            initial: null,
                            parentID: null,
                            value: item.ID,
                            usertype: null,
                            userImage: null
                        };
                    }));
                    break;
                case ACTYPE.PROJECTENTITYLIST: // custom entity list in Projects application
                case ACTYPE.PROJECTMETRICACCOUNTS:
                case ACTYPE.PLANENTITY:
                case ACTYPE.SALESADJUSTMENTENTITY:
                case ACTYPE.MANUALPROCESSTEAM:
                    response($.map(result, function (item) {
                        return {
                            entitytype: item.EntityType,
                            label: item.StandardName,
                            guid: null,
                            initial: null,
                            parentID: null,
                            value: item.ID,
                            usertype: null,
                            userImage: null
                        };
                    }));
                    break;
                case ACTYPE.NONFAILUREINTERVENTION:
                case ACTYPE.DOWNTIMEISSUE:
                case ACTYPE.DOWNTIMEWARNING:
                case ACTYPE.SCRAPDEFECT:
                case ACTYPE.UNLINKED_CONTPAQ_PRODUCTS:
                case ACTYPE.UNLINKED_SPARE_PART_PARTS:
                case ACTYPE.COMPANY_LOCATIONS_WITH_SALES_ORDER:
                case ACTYPE.PONUMBER:
              
                    response($.map(result, function (item) {
                        return {
                            entitytype: -1,
                            label: item.Name,
                            guid: null,
                            initial: null,
                            parentID: null,
                            value: item.ID,
                            usertype: null,
                            userImage: null
                        };
                    }));
                    break;
                case ACTYPE.MATERIALPO_CONTPAQ_PRODUCTS:
                    response($.map(result, function (item) {
                        return {
                            entitytype: -1,
                            label: item.StandardName,
                            guid: null,
                            initial: null,
                            parentID: null,
                            value: item.ID,
                            usertype: null,
                            userImage: null,
                            purchasedMaterialID: item.PurchasedMaterialID,
                            accountID: item.AccountID,
                            unitType: item.UnitType,
                            parentAccountID: item.ParentAccountID,
                            firmZoneDays: item.FirmZoneDays,
                            currencyType: item.CurrencyType,
                            unitPrice: item.UnitPrice,
                            costerCost: item.CosterCost,
                            standardCost: item.StandardCost,
                        };
                    }));
                    break;
                case ACTYPE.MACHINE_PART:
                    response($.map(result, function (item) {
                        return {
                            entitytype: -1,
                            label: item.PartName,
                            guid: null,
                            initial: null,
                            parentID: null,
                            value: item.PartID,
                            usertype: null,
                            userImage: null
                        };
                    }));
                    break;
                case ACTYPE.TAG:
                    response($.map(result, function (item) {
                        return {
                            entitytype: -1,
                            label: item.Title,
                            guid: null,
                            initial: null,
                            parentID: null,
                            value: item.ID,
                            usertype: null,
                            userImage: null
                        };
                    }));
                    break;
                case ACTYPE.EIGHTD:
                    response($.map(result, function (item) {
                        return {
                            entitytype: -1,
                            label: item.ID8D,
                            guid: null,
                            initial: null,
                            parentID: null,
                            value: item.ID8D,
                            usertype: null,
                            userImage: null
                        };
                    }));
                    break;
                case ACTYPE.TECHNICALCR:
                    response($.map(result, function (item) {
                        return {
                            entitytype: -1,
                            label: item.EntityName,
                            guid: null,
                            initial: null,
                            parentID: null,
                            value: item.EntityID,
                            usertype: null,
                            userImage: null
                        };
                    }));
                    break;
                case ACTYPE.CONTACT:
                    response($.map(result, function (item) {
                        return {
                            entitytype: -1,
                            label: item.ParentChildName,
                            guid: null,
                            initial: null,
                            parentID: null,
                            value: item.ID,
                            usertype: null,
                            userImage: null
                        };
                    }));
                    break;
                case ACTYPE.EIGHTD_WITH_NAME:
                    response($.map(result, function (item) {
                        return {
                            entitytype: -1,
                            label: item.ShortDescription,
                            guid: null,
                            initial: null,
                            parentID: null,
                            value: item.D8DID,
                            usertype: null,
                            userImage: null
                        };
                    }));
                    break;
                case ACTYPE.SPAREPARTLOCATION:
                    response($.map(result, function (item) {
                        return {
                            entitytype: -1,
                            label: item.LocationName,
                            guid: null,
                            initial: null,
                            parentID: null,
                            value: item.LocationID,
                            usertype: null,
                            userImage: null
                        };
                    }));
                    break;
                case ACTYPE.OTEACCOUNTS:
                    response($.map(result, function (item) {
                        return {
                            entitytype: -1,
                            label: item.AccountName,
                            guid: null,
                            initial: null,
                            parentID: null,
                            value: item.AccountID,
                            usertype: null,
                            userImage: null
                        };
                    }));
                    break;
                case ACTYPE.TRAININGMATRIXPLAYLIST:
                    response($.map(result, function (item) {
                        return {
                            entitytype: -1,
                            label: item.Title,
                            guid: null,
                            initial: null,
                            parentID: null,
                            value: item.ID,
                            usertype: null,
                            userImage: null
                        };
                    }));
                    break;
                case ACTYPE.CONTPAQ_PRODUCTS:
                    response($.map(result, function (item) {
                        return {
                            entitytype: -1,
                            label: item.StandardName,
                            contpaqProductID: item.ContpaqProductID,
                            contpaqName: item.Name,
                            purchasedMaterialID: item.PurchasedMaterialID,
                            accountID: item.AccountID,
                            parentAccountID: item.ParentAccountID,
                            unitPrice: item.UnitPrice,
                            unitType: item.UnitType,
                            packageQty: item.PackageQty,
                            initial: null,
                            parentID: null,
                            value: item.ID,
                        };
                    }));
                    break;
                case ACTYPE.JOB:
                case ACTYPE.JOB_EXCLUDE_LINKED:
                    response($.map(result, function (item) {
                        return {
                            entitytype: -1,
                            label: item.JobName,
                            guid: null,
                            initial: null,
                            parentID: null,
                            value: item.JobID,
                            usertype: null,
                            userImage: null
                        };
                    }));
                    break;
                case ACTYPE.PURCHASED_MATERIAL:
                    response($.map(result, function (item) {
                        return {
                            label: item.PartNumberWithRevision,
                            value: item.ID,
                            description: item.Description,
                            unitType: item.UnitOfMeasureID,
                            vendorPartNumber: item.VendorPartNumber,
                            currencyType: +item.CurrencyId,
                            costerCost: item.CosterCost,
                            standardCost: item.StandardCost,
                        };
                    }));
                    break;
                case ACTYPE.CONTPAQ_VENDORS_ONLY:
                case ACTYPE.COMPANYLOCATION:
                case ACTYPE.NON_CONTPAQ_VENDORS:
                case ACTYPE.COMPANY_LOCATIONS_WITH_BOM:
                case ACTYPE.COMPANY_LOCATIONS_WITH_BOM_SHIPTO:
                case ACTYPE.NON_CUSTOMER_LOCATION:
                case ACTYPE.NON_SUPPLIER_LOCATION:
                case ACTYPE.NON_CUSTOMER_SUPPLIER_LOCATION:
                    response($.map(result, function (item) {
                        return {
                            label: item.DisplayName,
                            guid: null,
                            initial: null,
                            parentID: item.ParentID,
                            value: item.ID,
                            usertype: item.IsContpaqVendor,
                            userImage: item.UserImage
                        };
                    }));
                    break;
                case ACTYPE.SHIPTO:
                    response($.map(result, function (item) {
                        return {
                            label: item.DisplayName,
                            guid: null,
                            initial: null,
                            parentID: null,
                            value: item.ID,
                            usertype: null,
                            userImage: null,
                        };
                    }));
                    break;
                case ACTYPE.TRAINING_MATRIX_ENTITY:
                    response($.map(result, function (item) {
                        return {
                            label: item.Name,
                            initial: null,
                            value: item.ID,
                            entitytype: item.EntityType,
                            isCustomUserGroup: item.IsCustomUserGroup,
                            acType: ACTYPE.TRAINING_MATRIX_ENTITY
                        };
                    }));
                    break;
                case ACTYPE.SHIPTO_AND_CELL_LIST:
                    response($.map(result, function (item) {
                        return {
                            label: item.NameWithParent,
                            value: item.ID,
                            entitytype: item.EntityType
                        };
                    }));
                    break;
                case ACTYPE.LEARNING_SUITE_RESOURCE_TASKS:
                    response($.map(result, function (item) {
                        var translationLabels = me.getLabel();
                        return {
                            label: item.Name + ' [' + translationLabels[LANGUAGETYPE[item.LanguageType - 1]] + ']',
                            guid: null,
                            initial: null,
                            value: item.ID
                        };
                    }));
                    break;
                case ACTYPE.CHILD_ACCOUNT:
                    response($.map(result, function (item) {
                        return {
                            label: item.AccountName,
                            value: item.AccountID,
                            parentid: item.ParentAccountID
                        };
                    }));
                    break;
                case ACTYPE.JOB_BY_USER:
                    response($.map(result, function (item) {
                        return {
                            label: item.JobNameWithType,
                            value: item.JobID,
                            jobidtype: item.JobIDType,
                            jobtype: item.JobType,
                            foxitemid: item.FOXItemID
                        };
                    }));
                    break;
                case ACTYPE.PDT_PROJECT_NUMBER:
                    response($.map(result, function (item) {
                        return {
                            label: item.PDTProjectNumber + ": " + item.Name,
                            value: item.PDTProjectNumber
                        };
                    }));
                    break;
                case ACTYPE.PROJECT_COLLECTION:
                    response($.map(result, function (item) {
                        return {
                            label: item.Name,
                            value: item.ID
                        };
                    }));
                    break;  
                case ACTYPE.PACKAGING_MATERIAL:
                    response($.map(result, function (item) {
                        return {
                            label: item.PartNumber,
                            value: item.ID
                        };
                    }));
                    break;
                case ACTYPE.NON_PACKAGING_PURCHASED_MATERIAL:
                    response($.map(result, function (item) {
                        return {
                            label: item.PartNumber,
                            value: item.ID
                        };
                    }));
                    break;

                case ACTYPE.PROJECT_TASK_ENTITY:
                    response($.map(result, function (item) {
                        return {
                            label: item.Name,
                            value: item.ID
                        };
                    }));
                    break;
                case ACTYPE.PURCHASED_MATERIAL_FROM_PACKAGING:
                    response($.map(result, function (item) {
                        return {
                            label: item.Name,
                            value: item.ID
                        };
                    }));
                    break;
                case ACTYPE.COMPANY_LOCATION_AND_CELLLIST:
                    response($.map(result, function (item) {
                        return {
                            label: item.Name,
                            value: item.ID,
                            entitytype: item.EntityType
                        };
                    }));
                    break;
                case ACTYPE.CR_AND_USER:
                    response($.map(result, function (item) {
                        return {
                            label: item.EntityName,
                            value: item.EntityID,
                            entitytype: item.EntityType
                        };
                    }));
                    break;
                case ACTYPE.CUSTOMERPART_WITH_SHIPTO_DESCRIPTION:
                    response($.map(result, function (item) {
                        return {
                            label: item.EntityName,
                            value: item.EntityID
                        };
                    }));
                    break;
                default:
                    response($.map(result, function (item) {
                        return {
                            entitytype: item.EntityType,
                            label: item.StandardName,
                            guid: item.GUID,
                            initial: item.Initial,
                            value: item.ID,
                            userImage: item.UserImage,
                            salaryType: item.SalaryType,
                            email : item.Email
                        };
                    }));
                    break;
                case ACTYPE.CUSTOMERPART_BY_SALESORDER:
                    response($.map(result, function (item) {
                        return {
                            label: item.CustomerPartNumber + ' ' + item.CustomerPartDescription,
                            value: item.ID,
                        };
                    }));
                    break;
                case ACTYPE.HTSCODETARIFF:
                    response($.map(result, function (item) {
                        return {
                            label: (item.IsPreferred ? '[Preferred] ' : '') + item.HTSCode + ' ' + item.CountryOfOrigin + '/' + item.Destination + ' (' + item.Percent + '%)',
                            value: item.HTSCodeId,
                            tariffId: item.TariffId,
                        };
                    }));
                    break;

                case ACTYPE.PARTFAMILY:
                    response($.map(result, function (item) {
                        return {
                            label: item.PartFamilyName,
                            value: item.PartFamilyID,
                        };
                    }));
                    break;
            }
        }
    });


    /* ========================================================================
     *  public methods
     * ========================================================================
    */

    //  set autocomplete
    child.setAutoComplete = function (container) {
        var list = '';
        if (container !== null) {
            if (typeof container === 'string') {
                container = $(container);
            }
            list = container.find(ELEM);
        } else {
            list = $(ELEM);
        }

        $(list).autocomplete2();
    };


    /* ========================================================================
     *  return
     * ========================================================================
    */
    return child;
}(jQuery, FD));